/**
 * Barrel exports for time entry detail tab components
 *
 * Provides convenient imports for all detail tab components.
 * Also exports as TimeEntryDetailTabComponents object for backward compatibility.
 */

export { TimeEntryDetails } from "./TimeEntryDetailsTab";
export { TicketDetailsTab } from "./TicketDetailsTab";
export { ContactDetailsTab } from "./ContactDetailsTab";
export { CompanyDetailsTab } from "./CompanyDetailsTab";
export { TimeEntryActivityTimelineTab } from "./TimeEntryActivityTimelineTab";

// Backward compatibility: Export as object matching original structure
import { TimeEntryDetails } from "./TimeEntryDetailsTab";
import { TicketDetailsTab } from "./TicketDetailsTab";
import { ContactDetailsTab } from "./ContactDetailsTab";
import { CompanyDetailsTab } from "./CompanyDetailsTab";
import { TimeEntryActivityTimelineTab } from "./TimeEntryActivityTimelineTab";

// Keys MUST match the `customComponent` strings in TimeEntryDetailConfig.ts.
export const TimeEntryDetailTabComponents = {
  TimeEntryDetails,
  TicketDetailsTab,
  ContactDetailsTab,
  CompanyDetailsTab,
  TimeEntryActivityTimeline: TimeEntryActivityTimelineTab,
};
